import React from 'react';
import {InertiaLink, useForm, usePage} from "@inertiajs/inertia-react";
import Layout from "@/Shared/Layout";
import SelectInput from "@/Shared/SelectInput";
import TextInput from "@/Shared/TextInput";
import DateInput from "@/Shared/DateInput";
import CustomRadio from "@/Shared/CustomRadio";
import TextArea from "@/Shared/TextArea";
import LoadingButton from "@/Shared/LoadingButton";

const Edit = () => {
  const {coupon, merchants} = usePage().props
  const {data, setData, errors, put, processing} = useForm({
    code: coupon.code || '',
    description: coupon.description || '',
    link: coupon.link || '',
    restrictions: coupon.restrictions || '',
    start_date:  coupon.start_date === '0000-00-00 00:00:00' ? null : coupon.start_date,
    expire_date: coupon.expire_date === '0000-00-00 00:00:00' ? null : coupon.expire_date,
    source: coupon.source || '',
    ysnTested: coupon.ysnTested || 0,
    ysnWorking: coupon.ysnWorking || 0,
    ysnDeleted: coupon.ysnDeleted || 0,
    internal_notes: coupon.internal_notes || '',
    merchant_id: coupon.merchant_id || ''
  });

  function handleSubmit(e) {
    e.preventDefault();
    put(route('added.coupons.update', coupon.id).url());
  }

  return (
    <div>
      <h1 className="mb-8 text-3xl font-bold">
        <InertiaLink
          href={route('coupons')}
          className="text-indigo-600 hover:text-indigo-700"
        >
          Coupons
        </InertiaLink>
        <span className="font-medium text-indigo-600"> /</span> Create
      </h1>
      <div className="max-w-3xl overflow-hidden bg-white rounded shadow">
        <form onSubmit={handleSubmit}>
          <div className="flex flex-wrap p-8 -mb-8 -mr-6">
            <SelectInput
              className="w-full pb-8 pr-6 lg:w-1/2"
              label="Merchant"
              name="merchant_id"
              errors={errors.merchant_id}
              value={data.merchant_id}
              onChange={e => setData('merchant_id', e.target.value)}
            >
              {merchants[0].map(({merchant_id, merchant_name}) => (
                <option key={merchant_id} value={merchant_id}>
                  {merchant_name}
                </option>
              ))}
            </SelectInput>
            <TextInput
              className="w-full pb-8 pr-6 lg:w-1/2"
              label="Code"
              name="code"
              type="text"
              errors={errors.code}
              value={data.code}
              onChange={e => setData('code', e.target.value)}
            />
            <TextInput
              className="w-full pb-8 pr-6"
              label="Link"
              name="link"
              type="text"
              errors={errors.link}
              value={data.link}
              onChange={e => setData('link', e.target.value)}
            />
            <DateInput
              date={data.start_date}
              setDate={setData}
              valueName={'start_date'}
              label={'Start Date'}
              errors={errors.start_date}
            />
            <DateInput
              date={data.expire_date}
              setDate={setData}
              valueName={'expire_date'}
              label={'Expiration Date'}
              errors={errors.expire_date}
            />
            <TextInput
              className="w-full pb-8 pr-6"
              label="Source"
              name="source"
              type="text"
              errors={errors.source}
              value={data.source}
              onChange={e => setData('source', e.target.value)}
            />
            <CustomRadio
              label="Tested"
              name="ysnTested"
              errors={errors.ysnTested}
              value={+data.ysnTested}
              onChange={e => setData('ysnTested', e.target.value)}
            />
            <CustomRadio
              label="Working"
              name="ysnWorking"
              errors={errors.ysnWorking}
              value={+data.ysnWorking}
              onChange={e => setData('ysnWorking', e.target.value)}
            />
            <CustomRadio
              label="Deleted"
              name="ysnDeleted"
              errors={errors.ysnDeleted}
              value={+data.ysnDeleted}
              onChange={e => setData('ysnDeleted', e.target.value)}
            />
            <TextArea
              className="w-full pb-8 pr-6"
              label="Description"
              name="description"
              errors={errors.description}
              value={data.description}
              onChange={e => setData('description', e.target.value)}
            />
            <TextArea
              className="w-full pb-8 pr-6"
              label="Restrictions"
              name="restrictions"
              errors={errors.restrictions}
              value={data.restrictions}
              onChange={e => setData('restrictions', e.target.value)}
            />
            <TextArea
              className="w-full pb-8 pr-6"
              label="Additional Comments"
              name="internal_notes"
              errors={errors.internal_notes}
              value={data.internal_notes}
              onChange={e => setData('internal_notes', e.target.value)}
            />
          </div>
          <div className="flex items-center justify-end px-8 py-4 bg-gray-100 border-t border-gray-200">
            <LoadingButton
              loading={processing}
              type="submit"
              className="btn-default"
            >
              Edit Coupon
            </LoadingButton>
          </div>
        </form>
      </div>
    </div>
  );
};

Edit.layout = page => <Layout title="Edit coupon" children={page} />;

export default Edit;
